// extracted by mini-css-extract-plugin
module.exports = {"container":"CVSection_container__PQhgb","main":"CVSection_main__oVcWZ","bottom":"CVSection_bottom__5B3d5","button-container":"CVSection_button-container__icayQ"};